export default __webpack_public_path__ + "static/media/pause.e0d94b7f.svg";